module.exports = __webpack_public_path__ + "static/media/logo-observatorio-laboral-para-la-educacion.7c8b1169.png";